import { mapActions } from 'vuex';

const loadTenders = {
  methods: {
    ...mapActions('projectTenders', ['loadTenders']),
    async localLoadTender({ status = 'active', additionally = false } = {}) {
      try {
        const projectId = this.$route.params.id;
        await this.loadTenders({ projectId, status, additionally });
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export default loadTenders;
